module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-jumbotron', {
    attrs: {
      "header": "Über slotlist.info"
    }
  }, [_c('p', {
    staticClass: "text-justify"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" wurde von\n    "), _c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT"
    }
  }, [_vm._v("MorpheusXAUT")]), _vm._v(" entwickelt, da das andauernde Neu-Registrieren bei zahllosen ArmA-Communities, nur um bei deren Missionen mitzuspielen, nervig wurde. Das Tool erlaubt eine einfachere Erstellung und Verwaltung von Missionen und bietet schnellen und direkten Zugang für alle Benutzer - alles was dafür benötigt wird, ist ein Steam Account - und diesen sollte jeder hoffentlich haben, ansonsten wird das ArmA-Spielen schwer\n    "), _c('i', {
    staticClass: "fa fa-smile-o"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Dieser Service wird gratis und ohne jegliche Garantie über Verfügbarkeit oder Erreichbarkeit angeboten - wir können\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" jederzeit und ohne weitere Vorwarnungen beendigen. Da es unser Ziel ist, ein einfaches Mittel für eine breite Anzahl an ArmA-Enthusiasten zur Verfügung zu stellen, bemühen wir uns, die höchste Verfügbarkeit und Langlebigkeit zu erreichen und freuen uns dabei über jedes Feedback.\n  ")], 1), _vm._v(" "), _c('h4', [_vm._v("Entwicklung")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" wird aktuell ausschließlich von\n    "), _c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT"
    }
  }, [_vm._v("MorpheusXAUT")]), _vm._v(" entwickelt. Die Repostories des Frontend- und Backend-Sourcecodes sowie die aktuell eingesetzten Versionen können unterhalb gefunden werden. Bitte gib diese Informationen in jeglichen Fehlermeldungen an, da es die Fehlersuche erleichtert.\n    ")], 1), _c('dl', {
    staticClass: "row"
  }, [_c('dt', {
    staticClass: "col-1"
  }, [_vm._v("Frontend")]), _vm._v(" "), _c('dd', {
    staticClass: "col-2"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT/slotlist-frontend"
    }
  }, [_c('i', {
    staticClass: "fa fa-github",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" slotlist-frontend")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-9"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.frontendVersion),
      expression: "frontendVersion"
    }]
  }, [_vm._v(_vm._s(_vm.frontendVersion))])]), _vm._v(" "), _c('dt', {
    staticClass: "col-1"
  }, [_vm._v("Backend")]), _vm._v(" "), _c('dd', {
    staticClass: "col-2"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT/slotlist-backend"
    }
  }, [_c('i', {
    staticClass: "fa fa-github",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" slotlist-backend")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-9"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.backendVersion),
      expression: "backendVersion"
    }]
  }, [_vm._v(_vm._s(_vm.backendVersion))])])]), _vm._v("\n    Die Repositories sowie deren Fehler-Tracker können außerdem dazu verwenden werden, um etwaige Bugs zu melden - alternativ kann dies über eine der unten genannten Kontaktmöglichkeiten geschehen.\n  "), _c('p'), _vm._v(" "), _c('h4', [_vm._v("Kontaktiere uns")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("\n    Sollten irgendwelche Probleme oder Fehler auftreten oder solltest du Vorschläge for unsere Seite haben, dann:\n    ")]), _c('dl', {
    staticClass: "row"
  }, [_c('dt', {
    staticClass: "col-sm-3"
  }, [_vm._v("öffne einen Fehlerbericht auf GitHub")]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-9"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT/slotlist-frontend/issues"
    }
  }, [_vm._v("Fehler-Tracker")])]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-3"
  }, [_vm._v("schick uns eine Email")]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-9"
  }, [_c('a', {
    attrs: {
      "href": "mailto:hello@slotlist.info?subject=slotlist.info - Hallo!"
    }
  }, [_vm._v("hello@slotlist.info")])]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-3"
  }, [_vm._v("tritt unserem Discord Server bei")]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-9"
  }, [_c('a', {
    attrs: {
      "href": "https://discord.gg/QZ5HpwT"
    }
  }, [_vm._v("Discord")])]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-3"
  }, [_vm._v("füge den Entwickler als Steam-Freund hinzu")]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-9"
  }, [_c('a', {
    attrs: {
      "href": "https://steamcommunity.com/id/morpheusxaut"
    }
  }, [_vm._v("MorpheusXAUT")])])]), _vm._v("\n    Kontakt-Details für rechtliche Anfrangen können im\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'imprint'
      }
    }
  }, [_vm._v("Impressum")]), _vm._v(" gefunden werden.\n  "), _c('p'), _vm._v(" "), _c('h4', [_vm._v("Spezielle Danksagungen")]), _vm._v(" "), _c('p', [_vm._v("\n    Zuletzt gibt es noch einige Leute, bei denen ich, MorpheusXAUT, mich bedanken möchte (in keiner bestimmten Reihenfolge):\n    ")]), _c('dl', {
    staticClass: "row"
  }, [_c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/Regner"
    }
  }, [_vm._v("Regner")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("dafür, dass er mir beim Start des Projektes und dem Einrichten von Allem geholfen und meine Fragenbombardierungen ertragen hat")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "http://spezialeinheit-luchs.de"
    }
  }, [_vm._v("[SeL] LeWarz")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("für das Vorschlagen von Features und Funktionalitäten, dem Testen der Services und dem allgemeinen Feedback")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "http://spezialeinheit-luchs.de"
    }
  }, [_vm._v("[SeL] Belbo")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("für Feature-Vorschläge und -Feedback sowie dem Korrekturlesen meiner teils wirren Übersetzungen")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "http://spezialeinheit-luchs.de"
    }
  }, [_vm._v("[SeL] Sinus")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("für Feedback zum Aufbau und Design der Seite, allgemeinem Testing und dem Füllen meiner Datenbank mit Datenmüll")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "http://spezialeinheit-luchs.de"
    }
  }, [_vm._v("[SeL] buur")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("für konstantes Feedback und Verbesserungsvorschläge und das Testen aller möglichen Funktionalitäten")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "https://task-force-wolf.de"
    }
  }, [_vm._v("[TFW] Isaac")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("für Feedback, Verbesserungsvorschläge und Fehlerberichte")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "http://www.jaegerzug-achilles.de"
    }
  }, [_vm._v("[JgZg-A] Steff")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("für Feature-Vorschläge und die Übersetzung ins Österreichische")])]), _vm._v(" "), _c('p')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e61fc902"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/i18n/views/About.de.vue
// module id = 576
// module chunks = 0